module.exports = __webpack_public_path__ + "img/text5.ffbaeedb.png";